<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" :placeholder="$t('common.search')" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div v-if="!loading" class="chat-filter-bar">
        <div v-for="(item, idx) in menuItems" :key="idx" class="filter-item" :class="{ active: menuIdx === idx }"
          @click="onMenuChange(idx)">
          <span class="filter-label">{{ item.label }}</span>
          <span v-if="showMenuCount(item)" class="filter-count" :class="{ emphasis: isMenuCountEmphasis(item, idx) }">
            {{ formatMenuCount(item.count) }}
          </span>
        </div>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" :element-loading-text="$t('chat.receivingMsg')"
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller class="scroll-box" :items="showConversations">
        <template v-slot="{ item }">
          <chat-item :conversation="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)"
            @info="onShowInfo(item)" @dnd="onDnd(item)" @top="onTop(item)" :active="item === activeConv"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeConv && !isSystem(activeConv)" :conversation="activeConv"></chat-box>
      <chat-system-box v-if="activeConv && isSystem(activeConv)" :conversation="activeConv"></chat-system-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      menuIdx: 0,
      // 未读/@我 tab 快照：{ menuIdx, keys }，进入 tab 时记录会话 key，切换 tab 时刷新
      frozenFilter: null,
      messageContent: "",
      group: {},
      groupMembers: []
    }
  },
  methods: {
    onActiveItem(conv) {
      this.chatStore.setActive(conv.key);
    },
    onDelItem(conv) {
      this.$confirm(this.$t('chat.deleteChat', { name: conv.showName }), this.$t('chat.deleteChatTitle'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        const data = { chatId: conv.targetId }
        let chatTypeText = "system";
        if (this.isPrivate(conv)) {
          chatTypeText = "private";
        } else if (this.isGroup(conv)) {
          chatTypeText = "group";
        }
        await this.$http({
          url: `/message/${chatTypeText}/deleteChat`,
          method: 'delete',
          data: data
        });
        await this.chatStore.remove(conv.key);
      });
    },
    onShowInfo(conv) {
      if (this.isPrivate(conv)) {
        this.$router.push("/home/friend?id=" + conv.targetId);
      } else if (this.isGroup(conv)) {
        if (!this.groupStore.isGroup(conv.targetId)) {
          this.$message.error(this.$t('chat.notInGroup'))
          return;
        }
        this.$router.push("/home/group?id=" + conv.targetId);
      }
    },
    onDnd(conv) {
      if (this.isPrivate(conv)) {
        this.setFriendDnd(conv, conv.targetId, !conv.isDnd)
      } else if (this.isGroup(conv)) {
        this.setGroupDnd(conv, conv.targetId, !conv.isDnd)
      } else {
        this.chatStore.setDnd(conv.key, !conv.isDnd)
      }
    },
    setFriendDnd(conv, friendId, isDnd) {
      const formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })

    },
    setGroupDnd(conv, groupId, isDnd) {
      const formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(conv.key, isDnd)
      })

    },
    onTop(conv) {
      if (this.isPrivate(conv)) {
        this.setFriendTop(conv, conv.targetId, !conv.isTop)
      } else if (this.isGroup(conv)) {
        this.setGroupTop(conv, conv.targetId, !conv.isTop)
      } else {
        this.chatStore.setTop(conv.key, !conv.isTop)
      }
    },
    setFriendTop(conv, friendId, isTop) {
      const formData = {
        friendId: friendId,
        isTop: isTop
      }
      this.$http({
        url: '/friend/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop)
        this.chatStore.setTop(conv.key, isTop)
      })
    },
    setGroupTop(conv, groupId, isTop) {
      const formData = {
        groupId: groupId,
        isTop: isTop
      }
      this.$http({
        url: '/group/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop)
        this.chatStore.setTop(conv.key, isTop)
      })
    },
    isShow(conv) {
      return !this.searchText || conv.showName.includes(this.searchText)
    },
    onMenuChange(idx) {
      if (this.menuIdx !== idx) {
        this.menuIdx = idx;
        // 切换 tab 时重建快照（全部 tab 清空快照）
        this.refreshFrozenFilter();
      }
    },
    // 进入未读/@我 tab 时快照当前符合条件的会话，避免点开后因已读状态变化而从列表消失
    refreshFrozenFilter() {
      if (this.menuIdx === 1 || this.menuIdx === 2) {
        const keys = this.searchableConversations
          .filter(conv => this.matchMenuFilter(conv, this.menuIdx))
          .map(conv => conv.key);
        this.frozenFilter = { menuIdx: this.menuIdx, keys };
      } else {
        this.frozenFilter = null;
      }
    },
    // 各 tab 角标数量：当前 tab 用快照计数，其他 tab 用实时过滤
    getMenuCount(menuIdx) {
      // 正在查看的未读/@我 tab：快照 + 新进来的会话
      if (this.frozenFilter && this.frozenFilter.menuIdx === menuIdx) {
        return this.countFrozenTabConversations(menuIdx);
      }
      const convs = this.searchableConversations;
      // 非当前 tab 或未读/@我 tab：实时统计，用于角标红色强调
      if (menuIdx === 1) {
        return convs.filter(conv => this.isUnreadConv(conv)).length;
      }
      if (menuIdx === 2) {
        return convs.filter(conv => conv.atMe || conv.atAll).length;
      }
      return convs.length;
    },
    // 快照内会话（含已读）+ 停留期间新符合 filter 的会话
    countFrozenTabConversations(menuIdx) {
      const frozenKeys = new Set(this.frozenFilter.keys);
      return this.searchableConversations.filter(conv => {
        return frozenKeys.has(conv.key) || this.matchMenuFilter(conv, menuIdx);
      }).length;
    },
    // 快照保留已读会话，同时并入新未读/@我会话
    isInFrozenTabList(conv) {
      return this.frozenFilter.keys.includes(conv.key) || this.matchMenuFilter(conv, this.menuIdx);
    },
    matchMenuFilter(conv, menuIdx) {
      menuIdx = menuIdx === undefined ? this.menuIdx : menuIdx;
      if (menuIdx === 1) {
        return this.isUnreadConv(conv);
      }
      if (menuIdx === 2) {
        return conv.atMe || conv.atAll;
      }
      return true;
    },
    isUnreadConv(conv) {
      return !conv.isDnd && conv.unreadCount > 0;
    },
    showMenuCount(item) {
      return item.alwaysShowCount || item.count > 0;
    },
    isMenuCountEmphasis(item, idx) {
      return item.emphasis && item.count > 0 && this.menuIdx !== idx;
    },
    formatMenuCount(count) {
      return count > 99 ? '99+' : count;
    },
    isPrivate(conv) {
      return this.$enums.CONVERSATION_TYPE.PRIVATE == conv.type
    },
    isGroup(conv) {
      return this.$enums.CONVERSATION_TYPE.GROUP == conv.type
    },
    isSystem(conv) {
      return this.$enums.CONVERSATION_TYPE.SYSTEM == conv.type
    }
  },
  computed: {
    activeConv() {
      return this.chatStore.activeConversation;
    },
    loading() {
      return this.chatStore.loading;
    },
    showConversations() {
      return this.chatStore.conversations.filter(conv => {
        if (!this.isShow(conv)) {
          return false;
        }
        if (this.menuIdx === 0) {
          return true;
        }
        // 未读/@我 tab 使用快照列表，全部 tab 实时过滤
        if (this.frozenFilter && this.frozenFilter.menuIdx === this.menuIdx) {
          return this.isInFrozenTabList(conv);
        }
        return this.matchMenuFilter(conv);
      });
    },
    searchableConversations() {
      return this.chatStore.conversations.filter(conv => this.isShow(conv));
    },
    menuItems() {
      return [
        {
          label: this.$t('chat.allTab'),
          count: this.getMenuCount(0),
          alwaysShowCount: true
        },
        {
          label: this.$t('chat.unreadTab'),
          count: this.getMenuCount(1),
          emphasis: true
        },
        {
          label: this.$t('chat.atMeTab'),
          count: this.getMenuCount(2),
          emphasis: true
        }
      ];
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }

  .chat-filter-bar {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 16px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);

    .filter-item {
      position: relative;
      display: inline-flex;
      align-items: baseline;
      gap: 4px;
      padding-bottom: 6px;
      cursor: pointer;
      user-select: none;

      .filter-label {
        font-size: 13px;
        color: var(--im-text-color-light);
        transition: color 0.2s ease;
      }

      .filter-count {
        font-size: 12px;
        color: var(--im-text-color-lighter);
        transition: color 0.2s ease;

        &.emphasis {
          color: var(--im-color-danger);
        }
      }

      &:hover {
        .filter-label {
          color: var(--im-text-color);
        }
      }

      &.active {
        .filter-label {
          color: var(--im-color-primary);
          font-weight: 600;
        }

        .filter-count {
          color: var(--im-color-primary);
          opacity: 0.85;
        }

        .filter-count.emphasis {
          color: var(--im-color-danger);
          opacity: 1;
        }

        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 2px;
          border-radius: 1px;
          background: var(--im-color-primary);
        }
      }
    }
  }

  .scroll-box {
    flex: 1;
    min-height: 0;
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}
</style>
